import { useEffect, useState } from 'react';

import { postOneTimeToken } from 'PrivateApis';

export const useOneTimeToken = () => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const abortController = new AbortController();

    postOneTimeToken(abortController)
      .then((res) => setToken(res.token))
      .catch((err) => window?.Sentry?.captureException?.(err));

    return () => {
      abortController?.abort();
    };
  }, []);

  return { token };
};
